import { render } from "./EventList.vue?vue&type=template&id=ae53410c&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=ae53410c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae53410c"

export default script